module.exports = __webpack_public_path__ + "img/letterI.9cdbad45.svg";